import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom"
import axios from 'axios';
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, InputBase, IconButton, Box, Menu, MenuItem, MenuList, Checkbox, FormControlLabel, ClickAwayListener, Grow, Paper, Popper, Badge } from '@material-ui/core/';
import CustomCheckbox from "./CustomCheckbox";
import clsx from "clsx";
import SearchIcon from '../icons/SearchIcon';
import translate from '../other/translate.json';
import CloseIcon from '../icons/CloseIcon';
import ButtonPrimary from './Button';
import ButtonPrimaryIcon from './ButtonPrimaryIcon';
import PropTypes from 'prop-types';
import SearchContentResultSearch from "./SearchContentResultSearch";
import CustomAutocomplete from './CustomsearchAutocomplete';
import utils from '../other/utils';
import config from '../other/config';
const { serverAPI } = config;
const compareApps = utils.compareApps



export default function SearchContent(props) {
	const { findText, searchAction, setSearchAction, menu, kloUser } = props;
	const { currentServerPart } = kloUser;
	let history = useHistory();
	const language = localStorage.getItem('language') || 'Ru';
	const classes = useStyles();
	const [searchFocus, setSearchFocus] = useState(false);
	const [findText1, setFindText1] = useState(findText);
	const [freezedFindText, _freezedFindText] = useState(findText);
	const [loading, setloading] = React.useState(true);
	const [searchResult, setSearhResult] = useState({ Applications: [], Products: [], Clouds: [], Solutions: [] });
	const [systems, setSystems] = useState([]);
	const [sortSystems, setSortSystems] = useState([]);
	const [currentSystems, _currentSystems] = useState([]);
	const [showAccurateSearchMenu, _showAccurateSearchMenu] = useState(false);
	const [accurateSearch, _accurateSearch] = useState(false);
	const [anchorMenu, _anchorMenu] = useState(null);
	const [rusSearch, _rusSearch] = useState('');
	const [kloStatuses, _kloStatuses] = useState({});
	const [loadingKloStatuses, _loadingKloStatuses] = useState(false);
	const prepareVal = (val) => typeof val === 'string' ? val : ''
	const getRelevantNumEqual = (a) => {
		
		let aCode = a.codeasvul.toUpperCase();			
		let aTitle = prepareVal(a.title).toUpperCase();		
		let search = findText1.toUpperCase();
		let aTags = prepareVal(a.tags).toUpperCase();
		let aDesc = prepareVal(a.briefdescription).toUpperCase() + prepareVal(a.HTMLFunction).toUpperCase() + prepareVal(a.HTMLContent).toUpperCase();
		let result = 0;
		if (aCode === search) {
			result = 10000;
		} else if (aCode.indexOf(search) > -1) {
			result = 5000;
		} else if (aTitle === search) {
			result = 1000;
		} else if (aTitle.indexOf(search) > -1) {
			result = 500;
		} else if (aDesc.indexOf(search) > -1) {
			result = 100;
		} else if (aTags.indexOf(search) > -1) {
			result = 10;
		}
		return result
			
	}
	const getRelevantNumEqualSol = (a) => {
		let aCode = a.AppsCodeNeeded.toUpperCase();			
		let aTitle = a.Title.toUpperCase();		
		let search = findText1.toUpperCase();
		
		let result = 0;
		if (aCode.indexOf(search) > -1) {
			result = 5000;
		} else if (aTitle === search) {
			result = 1000;
		} else if (a.findAppName === 1) {
			result = 500;
		} 
		return result

		/**По коду Приложения - вхождение в состав Готового решения
По точному наименованию Готового решения
По точному наименованию входящих в состав ГР Приложений
По ключевым словам (поиск по текстовым полям, см.п.1) */
			
	}
	const getRelevantNumEqualProd = (a) => {
		let need = a.AppsCodeNeeded.toUpperCase();			
		let aTitle = a.Title.toUpperCase();		
		let search = findText1.toUpperCase();
		let recomended = a.AppsCodeRecommended.toUpperCase();
		// let aDesc = a.briefdescription.toUpperCase() + a.HTMLFunction.toUpperCase() + a.HTMLContent.toUpperCase();
		let result = 10;
		if (need.indexOf(search) > -1) {
			result = 10000;
		} else if (recomended.indexOf(search) > -1) {
			result = 1000;
		} else if (aTitle === search) {
			result = 500;
		} else if (a.findAppName === 1) {
			result = 100;
		 
		}
		return result

		/**По коду Приложения - вхождение в состав Продукта как необходимое
По коду Приложения - вхождение в состав Продукта как рекомендуемое
По точному наименованию Продукта
По точному наименованию входящих в состав Продукта Приложений
По ключевым словам (поиск по текстовым полям, см.п.1) */
			
	}
	const sortSearchReasultByRelevant = (a, b) => {
		try {
			let aCode = a.codeasvul.toUpperCase();
			let bCode = b.codeasvul.toUpperCase();
			let aTitle = a.title.toUpperCase();
			let bTitle = b.title.toUpperCase();
			let search = findText1.toUpperCase();
			let aTags = a.tags.toUpperCase();
			let aDesc = a.briefdescription.toUpperCase() + a.HTMLFunction.toUpperCase() + a.HTMLContent.toUpperCase();
			let aSection = a.sn_title.toUpperCase();
			let bTags = b.tags.toUpperCase();
			let bDesc = b.briefdescription.toUpperCase() + b.HTMLFunction.toUpperCase() + b.HTMLContent.toUpperCase();
			let bSection = b.sn_title.toUpperCase();
			let aResult ='', bResult='';
			

// 			По коду
// По точному наименованию
// По наименованию
// По ключевым словам (поиск по текстовым полям, см.п.1)
// По тегам
// По остальным полям (поиск по сборным полям, см.п.2)
			//console.log("sortSearchReasultByRelevant",search === aCode  ,  bCode.indexOf(search)> -1)
			if (search === aCode && bCode.indexOf(search) > -1) {
				//console.log("1",findText1 , a.codeasvul  ,  findText1.indexOf(b.codeasvul) > -1)
				return -1
			} else if (search === aCode) {
				return -1

			} else if (aCode.indexOf(search) > -1 && bTitle.indexOf(search) > -1) {
				return -1
			} else if (aTitle === search  && bTitle.indexOf(search) > -1) {
				return -1
			} else if (aTitle.indexOf(search) > -1 && aDesc.indexOf(search) > -1) {
				return -1

			} else if (aDesc.indexOf(search) > -1 && bDesc.indexOf(search) === -1) {
				return -1
			} else if (aTags.indexOf(search) > -1 && bDesc.indexOf(search) > -1) {
				return -1
			} else if (aDesc.indexOf(search) > -1 && bDesc.indexOf(search)  === -1) {
				return -1

				//}else if (search === bCode  &&  search.indexOf(aCode) > -1) {
				//	console.log("2",findText1 , a.codeasvul  ,  findText1.indexOf(b.codeasvul) > -1, a,b)
				//	return -1
			} else if ((search === aCode || aCode.indexOf(search) > -1) && (bTitle === search || bTitle.indexOf(search) > -1)) {
				return 1
			} else if (search === bCode || bCode.indexOf(search) > -1) {
				return 1
			} else if ( bDesc.indexOf(search) > -1) {
				return 1
			}
			return 0
			} catch (e) {
				return 0
			}
		}

	const sortSearchReasultProdByRelevant = (a, b) => {
		try{
		let aCode = a.AppsCodeNeeded.toUpperCase() + a.AppsCodeRecommended.toUpperCase();
		let bCode = b.AppsCodeNeeded.toUpperCase() + b.AppsCodeRecommended.toUpperCase();
		let aTitle = a.Title.toUpperCase();
		let bTitle = b.Title.toUpperCase();
		let search = findText1.toUpperCase();
		let aBN = a.DirectionTitle.toUpperCase();
		let aDesc = a.BriefDescription.toUpperCase();
		let aSection = a.GroupTitle.toUpperCase();
		let bBN = b.DirectionTitle.toUpperCase();
		let bDesc = b.BriefDescription.toUpperCase();
		let bSection = b.GroupTitle.toUpperCase();
		let aSG = a.SubGroupTitle.toUpperCase();
		let bSG = b.SubGroupTitle.toUpperCase();
		const sotrByName = () =>  { if (bTitle > aTitle) return -1; if(aTitle > bTitle) return 1; return 0}
		//console.log("sortSearchReasultByRelevant",search === aCode  ,  bCode.indexOf(search)> -1)
		if (search === aCode && bCode.indexOf(search) > -1) {
			//console.log("1",findText1 , a.codeasvul  ,  findText1.indexOf(b.codeasvul) > -1)
			return -1
		} else if (search === aCode) {
			return -1

		} else if (aCode.indexOf(search) > -1 && bTitle.indexOf(search) > -1) {
			return -1
		}
		else if (aTitle.indexOf(search) > -1 && bSection.indexOf(search) > -1) {
			return -1

		} else if (aSection.indexOf(search) > -1 && bBN.indexOf(search) > -1) {
			return -1
		} else if (aBN.indexOf(search) > -1 && bSG.indexOf(search) > -1) {
			return -1
		} else if (aSG.indexOf(search) > -1 && bDesc.indexOf(search) > -1) {
			return -1
		} else if (aCode.indexOf(search) > -1 && bCode.indexOf(search)  > -1) {
			console.log("sortByName")
			return sotrByName()
		} else if (aDesc.indexOf(search) > -1 && bDesc.indexOf(search)  === -1) {
			return -1

			//}else if (search === bCode  &&  search.indexOf(aCode) > -1) {
			//	console.log("2",findText1 , a.codeasvul  ,  findText1.indexOf(b.codeasvul) > -1, a,b)
			//	return -1
		} else if ((search === aCode || aCode.indexOf(search) > -1) && (bTitle === search || bTitle.indexOf(search) > -1)) {
			console.log("gip");
			return 1
		} else if (search === bCode || bCode.indexOf(search) > -1) {
			return 1
		
		} else if (search === bCode || bCode.indexOf(search) > -1) {
			return 1
		
		} else if ( bDesc.indexOf(search) > -1) {
			return 1
		}		
		//console.log("gip1");
		return 0
		} catch (e) {
			return 0
		}
	}
	const compareTitles =(a,b) => {
		if (b.Title >  a.Title) {
			return -1
		} 
		if (b.Title <  a.Title) {
			return 1
		} 
		return 0
	}

	const getSearchResults = async (searchStr = findText1) => {
		if (searchStr && searchStr.length > 0) {
			let didCancel = false;			
			setloading(true)
			console.log("searchStr",searchStr,searchText, findText1)
			if (searchStr.length > 1000) {
				searchStr = searchStr.slice(0,999)
			}
			const result = await axios.get(`${serverAPI}/find/${language}?q=${encodeURIComponent(searchStr)}&inCu=${props.userCollection.inCu}&accurateSearch=${accurateSearch ? 1 : 0}`);
			if (!didCancel) {
				if (result && result.data) {
					setloading(false)
					_freezedFindText(searchStr)
					result.data.Applications = result.data.Applications.sort(compareApps).map(el => {el.relev = getRelevantNumEqual(el); return el}).sort(/*sortSearchReasultByRelevant*/ (a,b) => b.relev - a.relev);
					result.data.Applications  = result.data.Applications.filter(el => !["Архив","Archive"].includes(el.dateendsale) ).concat(result.data.Applications.filter(el => ["Архив","Archive"].includes(el.dateendsale) ))
					result.data.Products = result.data.Products.sort(compareTitles).map(el => {el.relev = getRelevantNumEqualProd(el); return el}).sort(/*sortSearchReasultByRelevant*/ (a,b) => b.relev - a.relev)//.sort(sortSearchReasultProdByRelevant)
					result.data.Solutions = result.data.Solutions.sort(compareTitles).map(el => {el.relev = getRelevantNumEqualSol(el); return el}).sort(/*sortSearchReasultByRelevant*/ (a,b) => b.relev - a.relev)//.sort(sortSearchReasultProdByRelevant)
					if (result.data.rusSearch !== undefined && (result.data.Applications.length > 0 || result.data.Products.length > 0 || result.data.Clouds.length > 0 || result.data.Solutions.length > 0)) {
						_rusSearch(result.data.rusSearch)
					} else {
						_rusSearch('')
					}
					setSearhResult(result.data)
					if (result.data.Applications) {
						let apps = result.data.Applications
						let systems = [];
						let cftCatalogs = []
						apps.map((app) => {
							if (!systems.includes(app.Title_catalog)) {
								systems.push(app.Title_catalog)
							}
							if (app.Title_catalog === 'ЦФТ-Банк' || app.Title_catalog === 'CFT-Bank') {
								cftCatalogs.push(app.codeasvul)
							}
						})
						if (systems.length > 0) {
							setSystems(systems)
						}

						/*if (cftCatalogs.length > 0) {
							let statuses = await props.getKloStatuses(cftCatalogs.filter((elem, index) => index < 24 ).join(','))
							_kloStatuses(statuses);
							if(cftCatalogs.length > 24){
								let allStatuses = await props.getKloStatuses(cftCatalogs.join(','))
								_kloStatuses(allStatuses);
							}
						}*/
					}
				}
			}
		

			
		} else {
			setSearhResult({ Applications: [], Products: [], Clouds: [], Solutions: [] })
		}
	}

	useEffect(() => {
		
		let didCancel = false;
		if (!didCancel) {
			getSearchResults();
		}
		return () => {
			didCancel = true;
		};
		
	}, [searchAction, accurateSearch]);

	useEffect(() => {
		//let sortSystems = menu.filter(elem => elem.ID_Category === 3).map(elem => elem.Title).filter(elem => systems.includes(elem));
		let menuSystems = menu.filter(elem => elem.ID_Category === 3).map(elem => elem.Title)
		setSortSystems(systems.sort((a, b) => { let positionA = menuSystems.indexOf(a) === -1 ? 1000 : menuSystems.indexOf(a); let positionB = menuSystems.indexOf(b) === -1 ? 1000 : menuSystems.indexOf(b); return positionA - positionB }))


	}, [menu, systems]);

	const textInput = useRef(null);

	const getParamURLQuery = (srt, param) => {
		let arr = srt.split('&')
		let res1 = arr.filter(el => el.includes(param))
		let Val = res1[0].split('=')[1];
		if (res1 && res1[0] && Val) {
			if (param === 'q=') {
				setFindText1(decodeURIComponent(Val).replace(/~percent~/g, '%'));
				setSearchAction(!searchAction)
			}
		}
	}

	const getDefaultParamURLQuery = (srt, param) => {
		let arr = srt.split('&')
		let res1 = arr.filter(el => el.includes(param))
		let Val = res1[0].split('=')[1];
		if (res1 && res1[0] && Val) {
			if (param === 'q=') {
				return decodeURIComponent(Val).replace(/~percent~/g, '%');
			}
		}
	}

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			if (searchResult && searchResult.Applications && currentServerPart !== undefined) {
				let cftCatalogs = searchResult.Applications.filter(el => el.Title_catalog === 'ЦФТ-Банк' || el.Title_catalog === 'CFT-Bank').map(el => el.codeasvul)
				if (cftCatalogs.length > 0) {
					_loadingKloStatuses(true);
					let statuses = await props.getKloStatuses(cftCatalogs.filter((elem, index) => index < 24).join(','))
					_kloStatuses(statuses);
					if (cftCatalogs.length > 24) {
						let allStatuses = await props.getKloStatuses(cftCatalogs.join(','))
						_kloStatuses(allStatuses);
					}
					_loadingKloStatuses(false);
				}
			}
		}
		if (!didCancel) {
			fetchData();
		}
		return () => {
			didCancel = true;
		};
	}, [searchResult, currentServerPart]);

	useEffect(() => {
		if (findText && findText.length > 0) {
			setFindText1(findText)
			setSearchAction(!searchAction)

		} else {
			if (history.location.search.includes('q=')) {
				getParamURLQuery(history.location.search, 'q=')

			}
		}

	}, [findText]);

	// 	useEffect(() => {

	// 		let didCancel = false;
	// 		async function fetchData() {				
	// 			const result = await axios.get(`${serverAPI}/getSearchPhrases`);
	// 			if (!didCancel) {
	// 				if (result && result.data) {
	// 					_searchPhrases(result.data)
	// 				}
	// 			}
	// 		}

	// 		fetchData();

	// 		return () => {
	// 			didCancel = true;
	// 		};		
	// }, []);

	const validateVal =(val) => {
		let hasFindValue = props.searchPhrases.map(el => el.searchValue).includes(val)
		if (!hasFindValue && typeof val === 'string') {
			val = val.replace(/'|"|;/gmi,'')
		}
		val = val.replace(/ALTER|CREATE|DELETE|DROP|EXEC(UTE){0,1}|INSERT( +INTO){0,1}|MERGE|SELECT|UPDATE|UNION( +ALL){0,1}|;/gmi,'')
		return val
	}

	const handleKeyDown = (val) => {
		// if (event.key === 'Enter' && val !== "") {
		
		val = validateVal(val);
		setFindText1(val)
		console.log("sc-handleKeyDown", val)
		getSearchResults(val)
		//console.log("!props.searchPhrases.includes(val)",hasFindValue)
		// 	val = textInput.current.firstChild.value
		// 	window.location.href = '/search?q=' + encodeURIComponent(val.replace(/%/g, "~percent~"));
		//setSearchAction(!searchAction)
		//}
		//window.location.href = '/search?q=' + encodeURIComponent(val.replace(/%/g, "~percent~"));
	}

	const search = (val) => {
		if (val !== "") {
			val = validateVal(val);
			console.log("vlval", val)
			//window.location.href = '/search?q=' + encodeURIComponent(val.replace(/%/g, "~percent~"));
			//setSearchAction(!searchAction)
			getSearchResults(val)
		}
	}

	function handleClick() {
		// textInput.current.focus();
		setSearchFocus(true)
	}

	const StyledBadge = withStyles((theme) => ({
		badge: {
			top: 1,
			right: 3,
			height: 8,
			width: 8,
			borderRadius: 5,
			backgroundColor: '#EB505E'
		},
	}))(Badge);

	const accurateSearchIconFill = showAccurateSearchMenu ? '#3C3C56' : '#BCBBD0';
	const checkSearchCondition = (elem, prop, search) => {
		//let string = ['HTMLContent','HTMLFunction'].includes(prop) ? elem[prop].replace(/[<.>]/g, ' ')/*.replace(/>/g, ' ')*/.toLowerCase() : elem[prop].toLowerCase();
		let string = ['HTMLContent', 'HTMLFunction'].includes(prop) ? elem[prop].replace(/[<.>]/g, ' ')/*.replace(/>/g, ' ')*/.toLowerCase() : elem[prop].toLowerCase();
		//replace(/(<([^>]+)>)/ig, "")
		string = " " + string + " "
		//console.log(string, search, string.indexOf(` ${search} `) > -1)
		console.log(prop,string,string.replace(/[^a-z0-9а-я]]/g, ' '))
		return (
			string === search || /*string.indexOf(`${search} `) > -1 || */string.indexOf(` ${search} `) > -1 || string.replace(/[^a-z0-9а-я]/g, ' ').indexOf(` ${search} `) > -1  //|| string.indexOf(` ${search}`) > -1
			//|| string.slice(0,search.length) === search || string.slice(-search.length) === search 
		)
	}
	const filtersearchResult = () => {
		if (!accurateSearch || true) {
			return searchResult
		} else {
			const search = freezedFindText.toLowerCase();

			const filteredApp = searchResult.Applications.filter((elem, index) => {
				return (
					checkSearchCondition(elem, 'codeasvul', search)
					|| checkSearchCondition(elem, 'briefdescription', search)
					|| checkSearchCondition(elem, 'title', search)
					|| checkSearchCondition(elem, 'HTMLContent', search)
					|| checkSearchCondition(elem, 'HTMLFunction', search)
					|| checkSearchCondition(elem, 'tags', search)
					)

			})
			const filteredClouds = searchResult.Clouds.filter((elem, index) => {
				return (checkSearchCondition(elem, 'AppsCodeNeeded', search) || checkSearchCondition(elem, 'BriefDescription', search) || checkSearchCondition(elem, 'Title', search) || checkSearchCondition(elem, 'HTMLContent', search))
			})
			const filteredProducts = searchResult.Products.filter((elem, index) => {
				return (checkSearchCondition(elem, 'AsvulCode', search) || checkSearchCondition(elem, 'BriefDescription', search) || checkSearchCondition(elem, 'Title', search) || checkSearchCondition(elem, 'HTMLContent', search))
			})
			const filteredSolutions = searchResult.Solutions.filter((elem, index) => {
				return (checkSearchCondition(elem, 'Title', search) || checkSearchCondition(elem, 'BriefDescription', search) || checkSearchCondition(elem, 'HTMLContent', search))
			})
			return {
				Applications: filteredApp,
				Clouds: filteredClouds,
				Products: filteredProducts,
				Solutions: filteredSolutions
			}
		}
	}

	const [searchText, setSearchText] = useState(getDefaultParamURLQuery(history.location.search, 'q='));

	const filteredSearchFunc = (arr, value) => {
		//console.log("filteredSearchFunc",value)
		if (!utils.hasProperty(value)) {
			return []
		}
		let array = arr.filter(el => el.searchValue.toLowerCase().trim().indexOf(value.toLowerCase().trim()) > -1).sort((a, b) => { return b.relev - a.relev }).slice(0, 6);

		return array
	}

	const searchContentResultSearchRef = useRef(null)

	const newSearch = () => {
		try {
			let value = textInput.current.getValue();
			search(value);
		} catch (e) {
			console.log(e)
			let value = document.getElementById('searchContentInput').value;
			search(value);

		}


	}

	return (
		<Grid container direction="column" justify="flex-start" alignItems="center">
			<Grid item container alignItems="center" style={{ /* outline: '1px solid red', */ minHeight: 56, marginBottom: 65 }}>
				<Typography className={classes.Title}>{translate.Words[`Search${language}`]} {/*: {findText1} */} </Typography>
			</Grid>

			<Grid item container style={{ /* outline: '1px solid red', */ marginBottom: 21 }}>

				<Grid
					itemID
					className={classes.search}
					style={{
						flexGrow: 1,
						backgroundColor: searchFocus ? '#fff' : '#EEEEF5',
						boxShadow: searchFocus ? '6px 6px 18px rgba(35, 72, 152, 0.08)' : undefined,
						height: 56,
						paddingLeft: 24,
						display: 'flex',
						alignItems: 'center'
					}}
				>
					<div className={classes.searchIcon}>
						<SearchIcon fill={'#BCBBD0'} />
					</div>

					<CustomAutocomplete
						ref={textInput}
						defaultValue={getDefaultParamURLQuery(history.location.search, 'q=')}
						onChange={(e, value) => {
							let correct;
							console.log(props.searchPhrases)
							setSearchText(value)
						}
						}
						id={'searchContentInput'}
						needCheckOptionModal = {true}
						label={translate.Words[`GlobalSearch${language}`]}
						//onFocus={(e) => setSearchFocus(false)}
						onBlur={() => setSearchFocus(!searchFocus)}
						onKeyDown={(val) => handleKeyDown(val)}
						//value={searchText}
						options={props.searchPhrases}
						filteredSearchFunc={filteredSearchFunc}
					/>

					<div
						className={classes.inputCloseBtn}
					>
						<IconButton
							aria-controls={showAccurateSearchMenu ? 'accurate-search-menu' : undefined}
							onClick={(e) => { _anchorMenu(e.currentTarget); _showAccurateSearchMenu(!showAccurateSearchMenu); }}
						>
							{accurateSearch
								?
								<StyledBadge
									color="secondary"
									variant="dot"
								//className ={classes.styledBadge}
								>

									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect x="4" y="5" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
										<rect x="4" y="17" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
										<rect x="4" y="11" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
										<circle cx="9" cy="6" r="3" fill={accurateSearchIconFill} />
										<circle cx="9" cy="18" r="3" fill={accurateSearchIconFill} />
										<circle cx="15" cy="12" r="3" fill={accurateSearchIconFill} />
										<circle cx="9" cy="6" r="1" fill="#EEEEF5" />
										<circle cx="9" cy="18" r="1" fill="#EEEEF5" />
										<circle cx="15" cy="12" r="1" fill="#EEEEF5" />
									</svg>


								</StyledBadge>
								:
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect x="4" y="5" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
									<rect x="4" y="17" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
									<rect x="4" y="11" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
									<circle cx="9" cy="6" r="3" fill={accurateSearchIconFill} />
									<circle cx="9" cy="18" r="3" fill={accurateSearchIconFill} />
									<circle cx="15" cy="12" r="3" fill={accurateSearchIconFill} />
									<circle cx="9" cy="6" r="1" fill="#EEEEF5" />
									<circle cx="9" cy="18" r="1" fill="#EEEEF5" />
									<circle cx="15" cy="12" r="1" fill="#EEEEF5" />
								</svg>


							}

						</IconButton>
						<IconButton aria-label="add to favorites"
							onClick={() => { setSearchFocus(false); setFindText1(''); if(!accurateSearch) {setSearchAction(!searchAction)}; _accurateSearch(false); textInput.current.clearValue(); }}

						// className={clsx( {
						// 	[classes.inputCloseBtnHide]: searchFocus === false
						// })}
						>
							<CloseIcon fill={'#BCBBD0'} />
						</IconButton>
					</div>


					{/* НИЖЕ КНОПКА ОЧИЩЕНИЯ СТРОКИ ПОИСКА */}

				</Grid>

				<Grid className={classes.btnSearchS}>
					<ButtonPrimaryIcon onClick={() => { newSearch() }} height={56} />
				</Grid>

				<Grid className={classes.btnSearchL}>
					<ButtonPrimary text={translate.Words[`Search_${language}`]} onClick={() => { newSearch() }} height={56} className={classes.btnSearchL} />
				</Grid>
			</Grid>

			<Popper open={showAccurateSearchMenu} anchorEl={anchorMenu} role={undefined} transition disablePortal placement={'bottom'}
				// modifiers={{      
				// 	arrow: {
				// 		enabled: true,
				// 		element: '[x-arrow]',
				// 	},
				// 	}}
				modifiers={{
					offset: {
						enabled: true,
						offset: "29, 5"
					}
				}}

				style={{ zIndex: 1, }}
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{ transformOrigin: placement === 'bottom' ? 'left bottom' : 'left top', }}
					>
						<ClickAwayListener onClickAway={(e) => {
							if (anchorMenu.current && anchorMenu.current.contains(e.target)) {
								return;
							}
							_showAccurateSearchMenu(false)
						}}>
							<Paper style={{
								maxHeight: 416, boxShadow: '4px 4px 30px rgba(35, 72, 152, 0.2)',
								borderRadius: '16px',
								//paddingTop: '8px',
								padding: '8px 32px 8px 15px',
								//paddingBottom: '8px'
								overflow: 'auto',
								//width:320

							}}
								className={classes.customMenuBody}
							>
								<Grid
									className={classes.list}
									item
									container
									direction="column"
									justify="space-between"
									alignItems="stretch"
								>
									<FormControlLabel
										onClick={() => {

											// _showAccurateSearchMenu(false);

											// let systems = [];
											// const search = freezedFindText.toLowerCase()
											// const apps = !accurateSearch ? searchResult.Applications.filter((elem, index) => {
											// 	return (checkSearchCondition(elem, 'codeasvul', search)
											// 		|| checkSearchCondition(elem, 'briefdescription', search)
											// 		|| checkSearchCondition(elem, 'title', search)
											// 		|| checkSearchCondition(elem, 'HTMLContent', search)
											// 		|| checkSearchCondition(elem, 'HTMLFunction', search))
											// })
											// 	:
											// 	searchResult.Applications;
											// apps.map((app) => {
											// 	if (!systems.includes(app.Title_catalog)) {
											// 		systems.push(app.Title_catalog)
											// 	}
											// })
											// setSystems(systems);

											// _accurateSearch(!accurateSearch);
											// // console.log(searchContentResultSearchRef.current)
											// //console.log(searchContentResultSearchRef.current.changePage)
											// searchContentResultSearchRef.current.changePage()
										}}
										onChange={(e) => {
											_showAccurateSearchMenu(false);
											/*let systems = [];
											const search = freezedFindText.toLowerCase()
											const apps = !accurateSearch ? searchResult.Applications.filter((elem, index) => {
												return (checkSearchCondition(elem, 'codeasvul', search)
													|| checkSearchCondition(elem, 'briefdescription', search)
													|| checkSearchCondition(elem, 'title', search)
													|| checkSearchCondition(elem, 'HTMLContent', search)
													|| checkSearchCondition(elem, 'HTMLFunction', search))
											})
												:
												searchResult.Applications;
											apps.map((app) => {
												if (!systems.includes(app.Title_catalog)) {
													systems.push(app.Title_catalog)
												}
											})
											setSystems(systems);*/
											let value = textInput.current.getValue();
											let val = validateVal(value);
											setFindText1(val)
											_accurateSearch(!accurateSearch);
											searchContentResultSearchRef.current.changePage()
											//getSearchResults()
										}}
										className={classes.formControl}
										value={accurateSearch}
										style={{ width: '100%', margin: '0 auto' }}
										control={
											<CustomCheckbox checked={accurateSearch} className={classes.customMenuCheckBox} />
										}
										label={
											<Typography className={classes.customMenuCheckBoxLabel}>
												{translate.Words[`AccurateSearch${language}`]}
											</Typography>
										}
										labelPlacement="end"
									/>
									{/* <FormControlLabel control={<Checkbox defaultChecked />} label="Label" /> */}
								</Grid>
							</Paper>
						</ClickAwayListener>
					</Grow>
				)}
			</Popper>

			<SearchContentResultSearch
				ref={searchContentResultSearchRef}
				freezedFindText={freezedFindText}
				key={`search${findText1}`}
				searchResult={filtersearchResult()}
				loading={loading}
				currentSystems={currentSystems}
				systems={sortSystems}
				_currentSystems={_currentSystems}
				menu={menu}
				keyboardLayout={accurateSearch ? '' : rusSearch}
				findText={findText1}
				usname={props.usname}
				getKloStatuses={props.getKloStatuses}
				_kloUser={props._kloUser}
				kloUser={props.kloUser}
				kloStatuses={kloStatuses}
				loadingKloStatuses={loadingKloStatuses}
				userCollection={props.userCollection}
				saveCollection={props.saveCollection}


			/>

		</Grid >
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Grid
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
			style={{ width: '100%' }}
		>
			{value === index && (
				<Box p={3} style={{ padding: 0, backgroundColor: 'transparent' }} >
					<Grid container spacing={3} id="a157" style={{ marginTop: 18, /* outline: '1px solid green' */ }}>{children}</Grid>
				</Box>
			)}
		</Grid>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

const useStyles = makeStyles(theme => ({
	Title: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '40px',
		lineHeight: '50px',
		color: '#000000'
	},

	search: {
		position: 'relative',
		borderRadius: 37,
		backgroundColor: 'transparent',
		marginLeft: 0,
		marginRight: theme.spacing(1),
		width: 'auto',
		height: 48,

		[theme.breakpoints.down(1366)]: {
			backgroundColor: 'transparent',
			'&:hover': {
				backgroundColor: '#fff'
			}
		},

	},

	searchIcon: {
		padding: theme.spacing(0, 2),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#8987A2',
		paddingLeft: 0,
		// right: 0
	},

	inputRoot: {
		color: '#8987A2',
		// outline: '1px solid purple',
		width: '100%'
	},

	inputFocused: {
		color: '#8987A2',
		// outline: '1px solid green',
		width: '100%'
	},

	inputInput: {
		padding: theme.spacing(1, 2),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		paddingRight: 96,
		transition: theme.transitions.create('width'),
		width: '100%',
		height: 40,

		[theme.breakpoints.up(1366)]: {
			// width: 0,
			'&:focus': {
				width: '100%',
			},
		},

		[theme.breakpoints.down(1366)]: {
			// width: 0,
			'&:focus': {
				// width: 207,
				width: '100%',
			},
		},
		color: '#8987A2'
	},

	inputCloseBtn: {
		position: 'absolute',
		top: 0,
		right: 0,
		margin: 4,

		// [theme.breakpoints.up(1365)]: {
		// 	display: 'none'
		// }
	},

	inputCloseBtnHide: {
		display: 'none'
	},

	customMenuBody: {
		'&:before': {
			content: '""',
			position: 'absolute',
			left: '116px',
			top: '-33px',
			border: '13.5px solid transparent',
			borderBottom: '21px solid #ffffff'
		}
	},
	customMenuCheckBoxLabel: {
		//margin:'auto 7px'
		marginLeft: 7
	},
	styledBadge: {
		top: 32,
		right: -6,
		height: 8,
		width: 8,
		borderRadius: 5,
		backgroundColor: '#EB505E'
	},

	btnSearchS: {
		[theme.breakpoints.up(696)]: {
			display: 'none',
		},
	},

	btnSearchL: {
		[theme.breakpoints.down(696)]: {
			display: 'none',
		},
	},

	// Title3: {
	// 	fontFamily: 'Cera CY',
	// 	fontStyle: 'normal',
	// 	fontWeight: '500',
	// 	fontSize: '24px',
	// 	lineHeight: '32px',
	// 	color: '#24262A'
	// }
}));
